import React from 'react';

import { MessageMetadata } from '@admin/components/messages/metadata';

import { MessageFromQuery, PhoneWithName } from './types';
import { getStatusClass, getStatusLabel } from './utils';

interface MessageItemProps {
  message: MessageFromQuery;
  phoneList: PhoneWithName[];
  onImageClick: (imageUrl: string) => void;
  onResolveThread: (message: MessageFromQuery) => void;
  loadingState: { resolvingThread: boolean };
}

export const MessageItem: React.FC<MessageItemProps> = ({
  message,
  phoneList,
  onImageClick,
  onResolveThread,
  loadingState,
}) => {
  return (
    <li className={`alert list-group-item list-item-lg ${message.kind === 'inbound' ? 'alert-info' : ''}`}>
      <div className="row">
        <div className="col-md-9">
          <p className="sms-body">{message.body}</p>
          {message.images.length > 0 && (
            <p>
              {message.images.map((image) => (
                <span key={image.id}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      onImageClick(image.source);
                    }}
                  >
                    <img
                      style={{ height: '100px' }}
                      src={`${image.source}?resize=100x100&crop=clip`}
                      alt="Message attachment"
                    />
                  </a>
                </span>
              ))}
            </p>
          )}
          <small>
            <MessageMetadata message={message} phoneList={phoneList} />
            {message.kind === 'outbound' && (
              <>
                {' '}
                <span className={getStatusClass(message)}>{getStatusLabel(message)}</span>
              </>
            )}
          </small>
        </div>
        <div className="col-md-3">
          {message.resolvable && (
            <div className="resolve-container">
              <button
                className="btn btn-danger"
                onClick={() => onResolveThread(message)}
                disabled={loadingState.resolvingThread}
              >
                {loadingState.resolvingThread ? 'Resolving...' : 'Mark as Resolved'}
              </button>
              <br />
              {message.kind === 'inbound' && (
                <p className="pull-right resolve-text">
                  Or, send a new message to <br />
                  resolve automatically.
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </li>
  );
};
